import React, { useState, useEffect } from "react";
import { styled, useTheme } from "@mui/material/styles";
import {
  Box,
  ButtonBase,
  Chip,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Stack,
  Tooltip
} from "@mui/material";
//import { getUserRole} from "../../diot/redux/Thunk/RoutesThunk";
import {  bellIcon } from "../../diot/assets"
import Drawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CircleIcon from "@mui/icons-material/Circle";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate, useLocation } from "react-router-dom";
import { Auth } from "aws-amplify";
import { connect } from "react-redux";
import ErrorIcon from "@mui/icons-material/Error";
import moment from 'moment';


// import { useAuthenticator } from "@aws-amplify/ui-react";


import { AppLogo, RehrigLogo } from "../../assets";
//import IrisWhiteTextLogo from "../../assets/logo/IrisWhiteText.svg";
import IrisIconLogo from "../../assets/logo/IrisIcon.svg";
//import { LicenseInfo } from '@mui/x-license';
import {
    qcBotItems,
    loadValidationItems,
    warehouseInsightItems,
    deliveryInsights, expressDeliveryItems,
} from "./consts/navListItems";
import { checkAccess } from "../../redux/Thunk/AuthThunk";
import {getCentralAdminId, getToken, getUserDetails, openNewURLAMI} from "../../redux/Thunk/WarehouseInsightsThunk"
import { getAlertsForLocation } from "../../diot/redux/Thunk/RoutesThunk"
import {
  setPageSubTitle,
  setPageChildTitle,
  setVorReferenceNumber,
  setCustomers,
  setSelectedCustomer,
  setSelectedDistributionCenter,
  setLoadingPalletsData,
  setPalletsData,
  // setLoadingPalletsDetails,
  setPalletInferenceID,
  setPalletDetails,
  //setGoBackToPalletReview
  setStartRefresh, setStopScanPallet
} from "../../redux/reducers/palletReview/PalletReviewReducer";
import {
  setPalletArchiveData,
  setLoadingPalletsArchiveData,
} from "../../redux/reducers/palletArchive/PalletArchiveReducer";

import {
  setStartDockDoorRefresh,
} from "../../redux/reducers/dockDoorControl/DockDoorControlReducer";

import {
  resetEmbedURL
} from "../../redux/reducers/warehouseInsights/WarehouseInsightsReducer"

import {SESSION_KEY, isMobile, isTabletDevice} from "../Common/helpers";
import Cookies from "js-cookie";
import {Constants} from "../../utils/Constants";
import ShowModal from "../Common/PermissionModal";
import {LicenseInfo} from "@mui/x-license";
import LoadingBar from "../Common/LoadingBar";
import {getUserRole} from "../../diot/redux/Thunk/RoutesThunk";
import CloseIcon from "@mui/icons-material/Close";
import {DataGrid} from "@mui/x-data-grid";
import {GlobalConstants} from "../../utils/GlobalConstants";
import {PalletData} from "../../utils/PalletData";
import {DataGridPro, getGridStringOperators, GridToolbar} from "@mui/x-data-grid-pro";
import useOrientation from "../Common/DeviceOrientation";
const drawerWidth = 0;
let bredcrumWidth = "500px";



const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
    ({ theme, open }) => ({
      flexGrow: 1,
      padding: theme.spacing(0.5,0,0.5,0),
      paddingLeft: "5px",
      paddingRight: "5px",
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
        zIndex: (isMobile()?999:""),
      marginLeft: isTabletDevice()?0:`-${drawerWidth - 45}px`,
      [theme.breakpoints.down("md")]: {
        marginLeft: 0,
      },

      ...(open && {
        transition: theme.transitions.create("margin", {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
      }),
    })
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

function SideNavDrawer({
                         children,
                         checkAccessFromProps,
                         getAlertsForLocation,
                         locationAlertsDataLoad,
                         locationAlertsData,
                         palletDetailsFromProps,
                         pageChildTitleFromProps,
                         pageSubTitleFromProps,
                         setPageChildTitleFromProps,
                         setPageSubTitleFromProps,
                         setVorReferenceNumberFromProps,
                         setCustomersFromProps,
                         setSelectedCustomerFromProps,
                         setSelectedDistributionCenterFromProps,
                         setLoadingPalletsDataFromProps,
                         setPalletsDataFromProps,
                         setPalletInferenceIDFromProps,
                         setPalletDetailsFromProps,
                         setPalletArchiveDataFromProps,
                         setLoadingPalletsArchiveDataFromProps,
                         setStartRefreshFromProps,
                         setStartDockDoorRefreshFromProps,
                         setResetEmbedURLFromProps, getUserDetails,

                         setOpenNewURLAMI,
                         getUserRole,
                         selectedCustomerListData,
                         selectedLocationListData,
                         isStopScanPalletFromProps,
                         setStartStopScanPalletFromProps
                       }) {
  const theme = useTheme();
  let navigate = useNavigate();
  let location = useLocation();
  const [open, setOpen] = useState(true);
  const [isQcBotCollapse, setIsQcBotCollapse] = useState(true);
  const [isLoadValidationCollapse, setIsLoadValidationCollapse] =
      useState(true);
    const [isExpressDeliveryCollapse, setIsExpressDeliveryCollapse] =
        useState(true);
  const [isWarehouseInsightsCollapse, setIsWarehouseInsightsCollapse] =
      useState(true);
  const [isDeliveryInsightsCollapse, setIsDeliveryeInsightsCollapse] =
      useState(true);
  const [selectedIndex, setSelectedIndex] = useState(1);
  const [pageGroupName, setPageGroupName] = useState("Active Learning");
  const [pageTitle, setPageTitle] = useState("Active Learning");

  const [qcBotVisible,setQCBotVisible] = useState(false);
  const [lvVisible,setLVVisible] = useState(false);
    const [expressVisible,setExpressVisible] = useState(false);
  const [skVisible,setSKVisible] = useState(false);
  const [diVisible,setDIVisible] = useState(false);
  const [amVisible,setAMVisible] = useState(false);
  const [isUserPermisisons,setUserPermissions] = useState(true);
  const [isProgess,setProgress] = useState(false)


  const [pageTitle2, setPageTitle2] = useState("");
  const [pageBreadCrum, setPageBreadCrum] = useState("");
  const [isShowTitle,setIsShowTitle] = useState(false);
  const [routeDetailsTitle,setRouteDetailsTitle] = useState("");
  const [alertsOpen, setAlertsOpen] = useState(false);
  const [supportOpen, setSupportOpen] = useState(false);

    const [diotustomer, setDIOTCustomer] = useState("");
    const [diotLocation, setDIOTLocation] = useState("");

    //let storedCustomer = null;//JSON.parse(localStorage.getItem("selectedCustomer"));
    //let storedLocation = null;//JSON.parse(localStorage.getItem("selectedLocation"));

    let orientation = useOrientation();

  const filterOperators = getGridStringOperators().filter(({ value }) =>
      ["contains" /* add more over time */].includes(value)
  );
  const [filterModel, setFilterModel] = useState({
    items: [
      {
        field: "rating",
        operator: ">",
        value: "2.5",
      },
    ],
  });



  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };


  // console.log("palletDetailsFromProps", palletDetailsFromProps);
  const handleListItemClick = (e, item) => {
    stopAutoRefresh();
    // console.log("handleListItemClick", item.id, item.path, item.name);s
  //  setCookies();
    setPageTitle(item.name);
    setSelectedIndex(item.id);
    setPageGroupName(item.parentText);
    navigate(item.path);
    setPageSubTitleFromProps("");
    setPageChildTitleFromProps("");
    setVorReferenceNumberFromProps("");
    if(isTabletDevice()){
      handleDrawerClose();
    }
      if(isMobile()){
          handleDrawerClose();
    }
  };

  const handleQcBotCollapse = () => {
    setIsQcBotCollapse(!isQcBotCollapse);
  };

  const handleLoadValidationCollapse = () => {
    setIsLoadValidationCollapse(!isLoadValidationCollapse);
  };

    const handleExpressDeliveryCollapse = () => {
        setIsExpressDeliveryCollapse(!isExpressDeliveryCollapse);
    };

  const handleGeneralFeaturesCollapse = () => {
    setIsWarehouseInsightsCollapse(!isWarehouseInsightsCollapse);
  };

  const handleDeliveryCollapse = () => {
    setIsDeliveryeInsightsCollapse(!isDeliveryInsightsCollapse);
  };

  // console.log("location", location.pathname);

  useEffect(()=>{
    // alert(window.screen.width);
    console.log("Side Navigation",location)
    //alert(isTabletDevice())
    //alert(navigator.platform)
    //alert(navigator.maxTouchPoints)
    LicenseInfo.setLicenseKey(process.env.REACT_APP_DATA_GRID_LICENSE_KEY);
    getLoginUserDetails();
   // document.addEventListener(Constants.LIFT_MAINTENANCE_EVENT, onLiftMaintenanceSelection);
    //document.addEventListener(Constants.LIFT_ADD_MAINTENANCE_EVENT, onLiftAddMaintenanceSelection);
   // document.addEventListener(Constants.ROUTE_SELECTION_EVENT, onRouteSelection);
    return () => {
      // Unbind the event listener on clean up
     // document.removeEventListener(Constants.ROUTE_SELECTION_EVENT, onRouteSelection);
    }
   // getUserRole()
    },[])



  const columns = [
    {
      field: 'time',
      headerName: 'Date & Time',
      flex: 1,
      renderCell: (params) => {
        const dateobj = moment(params.row.time).format("MMM DD, YYYY hh:mm a");
        return <>{dateobj}</>;
      },
    },
    { field: "liftId", headerName: "Lift ID",width:"150",align:"center",renderHeader: (params) => (
          <span className={"grid-column-header"} style={{width:"250px"}}>
          Lift ID
      </span>

      ) },

    {
      field: 'description',
      headerName: 'Alert Description',
      flex: 1.5,
    },
    {
      field: 'address',
      headerName: ' Alert Address',
      flex: 2,
    },
    {
      field: 'driverName',
      headerName: 'Driver Name',
      flex: 1,
    },
  ];

  let getLoginUserDetails = async ()=>{
    let locationPath = location.pathname;
    let isLogin = false;
    if(locationPath == '/' || locationPath == ''){
      isLogin = false;
    }else{
      isLogin = true;
    }
    setProgress(true);
    deliveryInsights.map((item,idx)=>{
      item.visible = false;
    })
    let response = await getUserDetails();
    console.log(response);
    setProgress(false);
    setQCBotVisible(false);
    setDIVisible(false);
    setLVVisible(false);
    setExpressVisible(false);
    setUserPermissions(true);
    if(response && response.payload && response.payload.Data){
      let roleName = response.payload.Data.role_name;
      GlobalConstants.IS_IRIS_UI_VISIBLE = false;
      let applications = response.payload.Data.applications;
      if(roleName == Constants.RPC_ADMIN || roleName == Constants.RPC_READ_ONLY){
        navigateToQCBot(isLogin);
        setNavigationItems(applications,roleName);
        GlobalConstants.IS_IRIS_UI_VISIBLE = true;
      }else{
        if(applications){
          if(applications.indexOf(8)>=0){
            GlobalConstants.IS_IRIS_UI_VISIBLE = true
          }
          setNavigationItems(applications,roleName);
          showUserNavigationMenu(applications,isLogin);
        }
      }

    }
  }

  let setNavigationItems = (apps,roleName)=>{
    deliveryInsights.map((item,idx)=>{
      item.visible = false;
      if(roleName == Constants.RPC_ADMIN || roleName == Constants.RPC_READ_ONLY){
        item.visible = true;
      }else{
        if(apps.indexOf(6)>=0){
          if(item.text == "Assets"){
            item.visible = true;

          }
        }if(apps.indexOf(4)>=0){
          if (item.text != "Assets"){
            item.visible = true;
          }

        }
      }
    })
  }

  let navigateToAuditPage = ()=>{
    let inferenceId = "";
    let dcId = "";
    let pathArray = location.pathname.split("/");
    if(pathArray && pathArray.length>3) {
      inferenceId = pathArray[2];
      dcId = pathArray[3];
      Constants.isAuditLoaded = false;
      navigate(`/auditpallet/${inferenceId}/${dcId}`);
    }
  }

  let navigateToQCBot = (flag)=>{
    setQCBotVisible(true);
    setDIVisible(true);
    setLVVisible(true);
    setSKVisible(true);
    setExpressVisible(true);
    setPageGroupName("Active Learning");
    setPageTitle("Active Learning");
    if(flag){
      if (location.pathname.includes("/auditpallet")){
        navigateToAuditPage();
      }else{
        navigate(location.pathname);
      }
    }else{
      navigate("/sm");
    }
  }

  let showUserNavigationMenu = (applications,flag)=>{
    let isExist = false;
    let isQcBotExist = false;
    let isLoadValidationExist = false;
      let isExpressDevliveryExist = false;
    let isRouteDBExist = false;
    let isAssetDBExist = false;
    let isWHInsightExist = false;

    if(applications.indexOf(7)>=0 || applications.indexOf(6)>=0 || applications.indexOf(4)>=0 || applications.indexOf(2)>=0 || applications.indexOf(1)>=0){

      if(applications.indexOf(7)>=0){
        isQcBotExist = true;
        setQCBotVisible(true);
      }
      if(applications.indexOf(2)>=0){
        isLoadValidationExist = true;
        setLVVisible(true);
      }
        if(applications.indexOf(9)>=0){
            isExpressDevliveryExist = true;
            setExpressVisible(true);
        }
      if(applications.indexOf(6)>=0 || applications.indexOf(4)>=0 ){
        setDIVisible(true);
        if(applications.indexOf(4)>=0){
          isRouteDBExist = true;
        }
        if(applications.indexOf(6)>=0){
          isAssetDBExist = true;
        }
      }
      if(applications.indexOf(1)>=0){
        isWHInsightExist = true;
        setSKVisible(true)
      }

      if(flag) {
        if (location.pathname.includes("qcbot") || location.pathname.includes("auditpallet") || location.pathname.includes("palletarchive")) {
          if (isQcBotExist) {
            isExist = true;
            if(location.pathname.includes("qcbot")){
              navigate("/sm");
            }else if(location.pathname.includes("auditpallet")){
              navigateToAuditPage();
            }else if(location.pathname.includes("palletarchive")){
              navigate("/palletarchive");
            }
          }
        }if(!isExist && location.pathname.includes("dockdoorcontrol")){
          if(isLoadValidationExist){
            isExist = true;
            navigate("/dockdoorcontrol");
          }
        }if(!isExist && location.pathname.includes("emailmanagement")){
              if(isExpressDevliveryExist){
                  isExist = true;
                  navigate("/emailmanagement");
              }
          }if(!isExist && (location.pathname.includes("operational-performance") || location.pathname.includes("picker-detail"))){
          if(isWHInsightExist){
            isExist = true;
            if(location.pathname.includes("operational-performance")){
              navigate("/operational-performance");
            }else if(location.pathname.includes("picker-detail")){
              navigate("/picker-detail");
            }
          }
        }if(!isExist && (location.pathname.includes("routestatus") || location.pathname.includes("lifts") || location.pathname.includes("casesperhour"))){
            if(isRouteDBExist){
              isExist = true;
              if(location.pathname.includes("routestatus")){
                navigate("/routestatus");
              }else if(location.pathname.includes("lifts")){
                navigate("/lifts");
              }else if(location.pathname.includes("casesperhour")){
                navigate("/casesperhour");
              }
            }
        }if(!isExist && location.pathname.includes("assets")){
          if(isAssetDBExist){
            if(location.pathname.includes("assets")){
              navigate("/assets");
            }
          }

        }
      }else{
        if(isQcBotExist){
          navigate("/sm");
        }else if (isLoadValidationExist){
          navigate("/dockdoorcontrol");
        }else if (isExpressDevliveryExist){
            navigate("/emailmanagement");
        }else if (isWHInsightExist){
          navigate("/operational-performance");
        }else if (isRouteDBExist){
          navigate("/routestatus");
        }else if (isAssetDBExist){
          navigate("/assets");
        }
      }

    }else if((applications.indexOf(5)>=0 || applications.indexOf(3)>=0)){
      setUserPermissions(false);
    }else{
      setUserPermissions(false);
    }
  }

  let resetDefaultValues = ()=>{
    Constants.EXPAND_COLLAPSE_PANEL = false;
    Constants.clearBarcodes();
    Constants.IS_BARCODE_SCANNER_START = false;
    Constants.strPalletId = "";
    setResetEmbedURLFromProps();
    setStartRefreshFromProps(false)
    setStartStopScanPalletFromProps(false)
    PalletData.selectedOperators = "";
    PalletData.selectedWrappers = "";
    PalletData.selectedRoutes = "";

    PalletData.selectedOperatorValues = [];
    PalletData.selectedRouteValues = [];
    PalletData.selectedWrapperValues = [];

    PalletData.isRouteSelected = false;
    PalletData.isOpratorSelected = false;
    PalletData.isWrapperSelected = false;

    console.log( GlobalConstants.SELECTED_PANEL)
    stopScanPallet();

  }

  let resetAssetTabs = ()=>{
    GlobalConstants.SELECTED_PANEL = "";
  }

  useEffect(() => {
   // setCookies();
      
    bredcrumWidth = "430px";
    if (location.pathname === "/sm") {
      setIsShowTitle(false);
      Constants.SCREEN_NAME = Constants.PALLET_REVIEW;
     // Constants.clearBarcodes();
      setSelectedIndex(1);
      setPageGroupName("Active Learning");
      setPageTitle("Active Learning");
      

      //console.log(pageSubTitleFromProps);
    } else if (location.pathname === "/dockdoorstatus") {
      //Constants.clearBarcodes();
      setIsShowTitle(false);
      setSelectedIndex(2);
      setPageGroupName("");
      setPageTitle("");
       setPalletDetailsFromProps({})
    //  setStartRefreshFromProps(false)
      setStartDockDoorRefreshFromProps(false)
      resetDefaultValues();
      resetAssetTabs();
    // setResetEmbedURLFromProps()
    } else if (location.pathname === "/dockdoorcontrol") {
     // Constants.clearBarcodes();
      setIsShowTitle(false);
      setSelectedIndex(3);
      setPageGroupName("Load Validation");
      setPageTitle("Dock Door Controls");
      setStartRefreshFromProps(false)
      resetDefaultValues();
      resetAssetTabs();
      //setResetEmbedURLFromProps()
    } else if (location.pathname === "/emailmanagement") {
        // Constants.clearBarcodes();
        setIsShowTitle(false);
        setSelectedIndex(11);
        setPageGroupName("Express Delivery");
        setPageTitle("Email Management");
        setStartRefreshFromProps(false)
        resetDefaultValues();
        resetAssetTabs();
        //setResetEmbedURLFromProps()
    }else if (location.pathname === "/operational-performance") {
     // Constants.clearBarcodes();
      setIsShowTitle(false);
      setSelectedIndex(4);
      setPageGroupName("Warehouse Insights");
      setPageTitle("Operational Performance");
      //setStartRefreshFromProps(false)
      setStartDockDoorRefreshFromProps(false)
      resetDefaultValues();
      resetAssetTabs();
     // setResetEmbedURLFromProps()
    } else if (location.pathname === "/palletarchive") {
      //Constants.clearBarcodes();
      setIsShowTitle(false);
      Constants.SCREEN_NAME = Constants.PALLET_ARCHIVE;
      setSelectedIndex(5);
      setPageGroupName("Active Learning");
      setPageTitle("Pallet Archive");
      //setStartRefreshFromProps(false)
      setStartDockDoorRefreshFromProps(false)
      //setResetEmbedURLFromProps()
      setPageSubTitleFromProps("");
      setPageChildTitleFromProps("")
      setPalletDetailsFromProps({})
      resetDefaultValues();
      resetAssetTabs();
    } else if (location.pathname === "/picker-detail") {
     // Constants.clearBarcodes();
      setIsShowTitle(false);
      setSelectedIndex(6);
      setPageGroupName("Warehouse Insights");
      setPageTitle("Selector Details");
      //setStartRefreshFromProps(false)
      setStartDockDoorRefreshFromProps(false)
      resetDefaultValues();
      resetAssetTabs();
      //setResetEmbedURLFromProps()
    }  else if (location.pathname === "/routestatus") {
      //Constants.clearBarcodes();
      setIsShowTitle(true);
       setSelectedIndex(7);
       setPageGroupName("Delivery Insights");
       setPageTitle("Route Status");
      // setStartRefreshFromProps(false)
       setStartDockDoorRefreshFromProps(false)
      resetDefaultValues();
      // setResetEmbedURLFromProps()
      //setOpenNewURLAMI("routestatus")
    }  else if (location.pathname === "/assets" || location.pathname === "/assets/") {
     // Constants.clearBarcodes();
      setIsShowTitle(true);
      setSelectedIndex(8);
      setPageGroupName("Delivery Insights");
      setPageTitle("Assets");
      //setStartRefreshFromProps(false)
      setStartDockDoorRefreshFromProps(false)
      resetDefaultValues();
      //setResetEmbedURLFromProps()
      //setOpenNewURLAMI("assets")
    }  else if (location.pathname === "/lifts" || location.pathname === "/liftMaintenance") {
      //Constants.clearBarcodes();
      setIsShowTitle(true);
      setSelectedIndex(9);
      setPageGroupName("Delivery Insights");
      setPageTitle("Lifts");
      setPageSubTitleFromProps("");
      //setPageSubTitleFromProps("Route Details");
     // setStartRefreshFromProps(false)
      setStartDockDoorRefreshFromProps(false)
      resetDefaultValues();
      resetAssetTabs();
     // setResetEmbedURLFromProps()
      //setOpenNewURLAMI("lifts")
    }  else if (location.pathname === "/casesperhour") {
      //Constants.clearBarcodes();
      setIsShowTitle(false);
      setSelectedIndex(10);
      setPageGroupName("Delivery Insights");
      setPageTitle("Delivery Performance");
     // setStartRefreshFromProps(false)
      setStartDockDoorRefreshFromProps(false)
      resetDefaultValues();
      resetAssetTabs();
      //setResetEmbedURLFromProps()
      //setOpenNewURLAMI("casesperhour")
    }  else if (location.pathname === "/column-definitions") {
      //Constants.clearBarcodes();
      setIsShowTitle(false);
      setSelectedIndex(10);
      setPageGroupName("Delivery Insights");
      setPageTitle("Delivery Performance");
     // setStartRefreshFromProps(false)
      setStartDockDoorRefreshFromProps(false)
      resetDefaultValues();
      resetAssetTabs();
      //setResetEmbedURLFromProps()
      //setOpenNewURLAMI("column-definitions")
    }
    setRouteDetailsTitle("")
    if (location.pathname.includes("/auditpallet")) {
      bredcrumWidth = "500px";
        setSelectedIndex(1);
      setPageSubTitleFromProps("Audit Pallet");
    }else if (location.pathname.includes("/routedetails")) {
        GlobalConstants.IS_ROUTE_DETAILS_LOADING = false;
      bredcrumWidth = "500px";
        setIsShowTitle(true);
        setPageGroupName("Delivery Insights");
        setPageTitle("Route Status");
      setPageSubTitleFromProps("Route Details");
       // resetDefaultValues();
        setSelectedIndex(7);

    }else if (location.pathname.includes("/liftMaintenance")) {
        setSelectedIndex(9);
      bredcrumWidth = "500px";
      setPageSubTitleFromProps("Alerts & Maintenance History");
        setIsShowTitle(true);
    }else if (location.pathname.includes("/addMaintenance")) {
        setSelectedIndex(9);
      bredcrumWidth = "750px";
      setPageChildTitleFromProps("Add Maintenance Record");
        setIsShowTitle(true);
    }


    return () => {

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);


let handleAlertClick = ()=>{
    let selCustomer = localStorage.getItem("routeDBCustomer");
    let storedCustomer = null;
    let storedLocation = null;
    if (selCustomer) {
        storedCustomer = JSON.parse(selCustomer);
    }
    let selLocation = localStorage.getItem("routeDBLocation");
    if (selLocation) {
        storedLocation = JSON.parse(selLocation);
    }
  const customerLocationdata = {
    customerId: storedCustomer?storedCustomer.customerId:selectedCustomerListData.customerId,
    locationId: storedLocation?storedLocation.locationId:selectedLocationListData.locationId,
    date: localStorage.getItem('routeDate'),
  }
  getAlertsForLocation(customerLocationdata)
  setAlertsOpen(true);
}
  const handleClose = () => {
    setAlertsOpen(false);
  };
  let stopAutoRefresh = () => {
    const event = new CustomEvent(Constants.ROUTE_DETAILS_BACK_EVENT, { detail: {} });
    document.dispatchEvent(event);
  }
  let stopScanPallet = () => {
    const event = new CustomEvent(Constants.STOP_SCAN_PALLET, { detail: {} });
    document.dispatchEvent(event);
  }

  let onClickSupport = ()=>{
    console.log("Support")
    setSupportOpen(true);
  }

  let handleSupportClose = ()=>{
    setSupportOpen(false);
  }



  return (
      <Box sx={{ display: "flex" }}>{isUserPermisisons?"":<ShowModal />}
        {alertsOpen &&
            <React.Fragment>
              <Dialog
                  open={alertsOpen}
                  onClose={handleClose}
                  sx={{
                    "& .MuiDialog-container": {
                      "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "1000px",  // Set your width here
                      },
                    },
                  }}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title" sx={{ fontSize: "24px" }}>
                  Notifications
                  <IconButton style={{ float: "right" }}>
                    <CloseIcon onClick={() => handleClose()} />
                  </IconButton>
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    <Box sx={{ width: "100%" }}>
                      <DataGridPro
                                sx={{
                                  height:"600px", width: "100%",
                                  display: "grid", borderColor: "#FFF !important",
                                  gridTemplateRows: "auto 1f auto",
                                  cursor: "pointer",
                                  "&, [class^=MuiDataGrid]": { border: "none" },
                                  "& .MuiDataGrid-cell": {
                                    border: 1,
                                    borderRight: 0,
                                    borderTop: 0,
                                    borderLeft: 0,
                                    borderColor: "#D4DFE8",
                                  },
                                  '& .MuiDataGrid-sortIcon': {
                                    opacity: 0,
                                  },
                                }}
                                rows={locationAlertsDataLoad ? [] : locationAlertsData}
                                getRowId={(row) => row.seqNumber}
                                columns={columns}
                                loading={locationAlertsDataLoad}
                                pageSizeOptions={[50, 100,500, 1000]}
                                pagination={true}
                                paginationMode="client"
                                sortingMode="client"
                                filterMode="client"
                                slots={{
                                  toolbar: GridToolbar,
                                  noResultsOverlay: () => (
                                      <Box
                                          sx={{
                                            display: "flex", height: "100%", justifyContent: "center",
                                            alignItems: "center", flexDirection: "column",
                                          }}>
                                        <Typography style={{fontWeight:"400", fontSize:"16px"}}>
                                          No Results Found
                                        </Typography>

                                      </Box>
                                  ),
                                  noRowsOverlay:() => (
                                      <Box
                                          sx={{
                                            display: "flex", height: "100%", justifyContent: "center",
                                            alignItems: "center", flexDirection: "column",
                                          }}>
                                        <Typography style={{fontWeight:"400", fontSize:"16px"}}>
                                          No Rows
                                        </Typography>
                                      </Box>
                                  ),
                                }}
                                slotProps={{
                                  toolbar: {
                                    showQuickFilter: true,
                                  },
                                }}
                                initialState={{
                                  pagination: { paginationModel: { pageSize: 100 } },
                                }}
                                disableRowSelectionOnClick
                                filterModel={filterModel}
                                onFilterModelChange={(newFilterModel) => setFilterModel(newFilterModel)}
                      />
                    </Box>
                  </DialogContentText>
                </DialogContent>
              </Dialog>
            </React.Fragment>
        }
        {supportOpen &&
            <React.Fragment>
              <Dialog
                  open={supportOpen}
                  onClose={handleSupportClose}
                  sx={{
                    "& .MuiDialog-container": {
                      "& .MuiPaper-root": {
                        width: "100%",
                        height:"300px",
                        maxWidth: "650px",  // Set your width here
                      },
                    },
                  }}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title" sx={{ fontSize: "24px" }}>
                  Customer Support
                  <IconButton style={{ float: "right" }}>
                    <CloseIcon onClick={() => handleSupportClose()} />
                  </IconButton>
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    <Box sx={{ width: "100%",paddingTop:"5%",paddingLeft:"15%" }}>
                      <Typography><b>Business Phone:</b> 1-866-742-8232</Typography>
                      <Typography sx={{paddingTop:"20px"}}><b>Support Email:</b> support@rehrig.com</Typography>
                    </Box>
                  </DialogContentText>
                </DialogContent>
              </Dialog>
            </React.Fragment>
        }
        <AppBar position="fixed" open={open}
            sx={{
              backgroundColor: "#ffffff",
              boxShadow: "none",
                zIndex: isMobile()?0:"",
            }}
        >
          <Toolbar>
            <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                edge="start"
                sx={{ mr: 2, ...(open && { display: "none" }) }}
            >
              <MenuIcon sx={{color: "black"}}/>
            </IconButton>
            <Box
                sx={{
                  display: (isMobile()?"none":"flex"),
                  justifyContent: "space-between",
                  width: "100%",
                  alignItems: "center",
                }}
            >
              <Box sx={{display:"flex", flexDirection:"column", width:"100%"}}>
                <Box sx={{textAlign:"center"}}>
                  {isProgess?<LoadingBar /> :""}
                </Box>
                
                  <Box sx={{display:"flex",bgcolor:"#ffffff", color:"#1e293b",
                    justifyContent:"space-between",height:"50px",padding:"5px 16px",
                    alignItems:"center", width:"100%", borderBottom:"1px solid #e8e9eaff"}}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0,paddingTop:"10px" }}>
                    <img src={IrisIconLogo} alt="SKU360" style={{ height: 28, display: 'block' }} />
                   &nbsp;<Typography variant="h6" sx={{ color: '#000', fontWeight: 800, fontSize: '1.1rem', 
                    letterSpacing: '0.04em', whiteSpace: 'nowrap' }}> SKU 360</Typography>
                  </Box>
                    &nbsp;&nbsp;&nbsp;
                    <Tooltip title="Logout">
                    <IconButton
                    onClick={() => {
                      navigate("/");
                      Auth.signOut();
                      setTimeout(()=>{
                        let newloc = window.location.origin;
                        window.location.href = newloc;
                      },1000)
                    }}
                    aria-label="signOut"
                    size="small"
                    sx={{ color: "#000", "&:hover": { color: "#000", bgcolor: "rgba(0,0,0,0.0)" } }}
                >
                  <LogoutIcon sx={{ fontSize: 20 }} />
                </IconButton>
                </Tooltip>
                    <Typography variant="body1" color="#FFF" sx={{ fontWeight: 700,display:"none" }}>Logout</Typography>
                    </Box>
                 
              </Box>
            </Box>

          </Toolbar>
        </AppBar>
        <Drawer
            sx={{
                marginLeft:(isMobile()?"40px":""),

              zIndex:isMobile()?9999:(isTabletDevice()?1200:""),
              width: isTabletDevice() ? "100%":isMobile()?"100%":drawerWidth,
              [theme.breakpoints.down("md")]: {
                width: 0,
              },
              flexShrink: 0,
              "& .MuiDrawer-paper": {
                width: isTabletDevice() ? "100%":isMobile()?"100%":drawerWidth,
                boxSizing: "border-box",
              },
            }}
            variant="persistent"
            anchor="left"
            open={open}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
        >
          <DrawerHeader>
            <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "space-between",
                  marginY: "20px",
                }}
            >
              <IconButton aria-label="logo" onClick={() => navigate("/")}>
                <img src={AppLogo} alt="logo" style={{ marginLeft: "10px" }} />
              </IconButton>
              <IconButton onClick={handleDrawerClose}>
                {theme.direction === "ltr" ? (
                    <ChevronLeftIcon />
                ) : (
                    <ChevronRightIcon />
                )}
              </IconButton>
            </Box>
          </DrawerHeader>
          <Divider />

          <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%",
              }}
          >
            <Box>
              <List>
                <ListItem
                    disablePadding
                    sx={{display:(qcBotVisible?"block":"none")}}
                    onClick={handleQcBotCollapse}
                >
                  <ListItemButton sx={{paddingLeft:"5px"}}>
                    {isQcBotCollapse ? <ExpandLessIcon sx={{rotate:"180deg"}} /> : <ExpandLessIcon sx={{rotate:"90deg"}} />}
                    <ListItemText>
                      <Typography variant="h4" color="#111540">
                        Active Learning
                      </Typography>
                    </ListItemText>

                  </ListItemButton>
                </ListItem>
                <Collapse in={isQcBotCollapse} timeout="auto" unmountOnExit sx={{paddingLeft:"10px",display:(qcBotVisible?"":"none")}}>
                  {qcBotItems.map((item, index) => (
                      <ListItem
                          key={item.id}
                          disablePadding
                          sx={{ display: "block" }}
                      >
                        <ListItemButton
                            sx={{
                              "&.Mui-selected": {
                                backgroundColor: "#2776CC",
                                color: "#FFFFFF",
                              },
                              "&.MuiListItemButton-root:hover": {
                                backgroundColor: "#2776CC",
                                color: "#FFFFFF",
                              },
                            }}
                            selected={selectedIndex === item.id}
                            onClick={(event) => handleListItemClick(event, item)}
                        >
                          <ListItemText>
                            <Typography
                                variant="body2"
                                sx={{
                                  fontWeight: selectedIndex === item.id && "600",
                                }}
                            >
                              {item.text}
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </ListItem>
                  ))}
                </Collapse>
                <Box sx={{ mt: "10px" }} />
                <ListItem 
                    // key={item.text}
                    disablePadding
                    sx={{display: (lvVisible?"none":"none") }}
                    onClick={handleLoadValidationCollapse}
                >
                  <ListItemButton sx={{paddingLeft:"5px",}}>
                    {isLoadValidationCollapse ? (<ExpandLessIcon sx={{rotate:"180deg"}} />) : (
                        <ExpandLessIcon sx={{rotate:"90deg"}} />
                    )}
                    <ListItemText>

                      <Typography variant="h4" color="#111540">
                        Load Validation
                      </Typography>
                    </ListItemText>

                  </ListItemButton>
                </ListItem>
                <Collapse
                    in={isLoadValidationCollapse}
                    timeout="auto"
                    unmountOnExit
                    sx={{paddingLeft:"10px",display: (lvVisible?"none":"none") }}
                >
                  {loadValidationItems.map((item, index) => (
                      <ListItem
                          key={item.id}
                          disablePadding
                          sx={{ display: "block" }}
                      >
                        <ListItemButton
                            sx={{
                              "&.Mui-selected": {
                                backgroundColor: "#2776CC",
                                color: "#FFFFFF",
                              },
                              "&.MuiListItemButton-root:hover": {
                                backgroundColor: "#2776CC",
                                color: "#FFFFFF",
                              },
                            }}
                            selected={selectedIndex === item.id}
                            onClick={(event) => handleListItemClick(event, item)}
                        >
                          <ListItemText>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: selectedIndex === item.id && "600",
                                  }}
                              >
                                {item.text}
                              </Typography>
                              {item.name === "Dock Door Controls" && (
                                  <CircleIcon
                                      sx={{
                                        fontSize: 10,
                                        color: "red",
                                        marginLeft: "10px",
                                        display:"none"
                                      }}
                                  />
                              )}
                            </Box>
                          </ListItemText>
                        </ListItemButton>
                      </ListItem>
                  ))}
                </Collapse>
                  <Box sx={{ mt: "10px" }} />
                  <ListItem
                      // key={item.text}
                      disablePadding
                      sx={{display: (expressVisible?"none":"none") }}
                      onClick={handleExpressDeliveryCollapse}
                  >
                      <ListItemButton sx={{paddingLeft:"5px",}}>
                          {isExpressDeliveryCollapse ? (<ExpandLessIcon sx={{rotate:"180deg"}} />) : (
                              <ExpandLessIcon sx={{rotate:"90deg"}} />
                          )}
                          <ListItemText>

                              <Typography variant="h4" color="#111540">
                                  Express Delivery
                              </Typography>
                          </ListItemText>

                      </ListItemButton>
                  </ListItem>
                  <Collapse
                      in={isExpressDeliveryCollapse}
                      timeout="auto"
                      unmountOnExit
                      sx={{paddingLeft:"10px",display: (expressVisible?"none":"none") }}
                  >
                      {expressDeliveryItems.map((item, index) => (
                          <ListItem
                              key={item.id}
                              disablePadding
                              sx={{ display: "block" }}
                          >
                              <ListItemButton
                                  sx={{
                                      "&.Mui-selected": {
                                          backgroundColor: "#2776CC",
                                          color: "#FFFFFF",
                                      },
                                      "&.MuiListItemButton-root:hover": {
                                          backgroundColor: "#2776CC",
                                          color: "#FFFFFF",
                                      },
                                  }}
                                  selected={selectedIndex === item.id}
                                  onClick={(event) => handleListItemClick(event, item)}
                              >
                                  <ListItemText>
                                      <Box sx={{ display: "flex", alignItems: "center" }}>
                                          <Typography
                                              variant="body2"
                                              sx={{
                                                  fontWeight: selectedIndex === item.id && "600",
                                              }}
                                          >
                                              {"Email Management"}
                                          </Typography>
                                          {item.name === "Email Management" && (
                                              <CircleIcon
                                                  sx={{
                                                      fontSize: 10,
                                                      color: "red",
                                                      marginLeft: "10px",
                                                      display:"none"
                                                  }}
                                              />
                                          )}
                                      </Box>
                                  </ListItemText>
                              </ListItemButton>
                          </ListItem>
                      ))}
                  </Collapse>
                <Box sx={{ mt: "10px" }} />
                <ListItem
                    // key={item.text}
                    disablePadding
                    sx={{ display:(skVisible?"none":"none")}}
                    onClick={handleGeneralFeaturesCollapse}
                >
                  <ListItemButton sx={{paddingLeft:"5px"}}>
                    {isWarehouseInsightsCollapse ? (
                        <ExpandLessIcon sx={{rotate:"180deg"}} />
                    ) : (
                        <ExpandLessIcon sx={{rotate:"90deg"}}/>
                    )}
                    <ListItemText>
                      <Typography variant="h4" color="#111540">
                        Warehouse Insights
                      </Typography>
                    </ListItemText>

                  </ListItemButton>
                </ListItem>
                <Collapse
                    in={isWarehouseInsightsCollapse}
                    timeout="auto"
                    unmountOnExit
                    sx={{ paddingLeft:"10px",display:(skVisible?"":"none")}}
                >
                  {warehouseInsightItems.map((item, index) => (
                      <ListItem
                          key={item.id}
                          disablePadding
                          sx={{
                            selected: {
                              backgroundColor: "red",
                            },
                          }}
                      >
                        <ListItemButton
                            sx={{
                              "&.Mui-selected": {
                                backgroundColor: "#2776CC",
                                color: "#FFFFFF",
                              },
                              "&.MuiListItemButton-root:hover": {
                                backgroundColor: "#2776CC",
                                color: "#FFFFFF",
                              },
                            }}
                            selected={selectedIndex === item.id}
                            onClick={(event) => handleListItemClick(event, item)}
                        >
                          <ListItemText>
                            <Typography
                                variant="body2"
                                sx={{
                                  fontWeight: selectedIndex === item.id && "600",
                                }}
                            >
                              {item.text}
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </ListItem>
                  ))}
                </Collapse>

                <Box sx={{ mt: "10px" }} />
                <ListItem
                    // key={item.text}
                    disablePadding
                    sx={{ display:(diVisible?"none":"none")}}
                    onClick={handleDeliveryCollapse}
                >
                  <ListItemButton sx={{paddingLeft:"5px"}}>
                    {isDeliveryInsightsCollapse ? (
                        <ExpandLessIcon sx={{rotate:"180deg"}} />
                    ) : (
                        <ExpandLessIcon sx={{rotate:"90deg"}} />
                    )}
                    <ListItemText>
                      <Typography variant="h4" color="#111540">
                        Delivery Insights
                      </Typography>
                    </ListItemText>

                  </ListItemButton>
                </ListItem>
                <Collapse
                    in={isDeliveryInsightsCollapse}
                    timeout="auto"
                    unmountOnExit
                    sx={{paddingLeft:"10px"}}
                >
                  {deliveryInsights.map((item, index) => (


                      (item.visible ? (<ListItem
                              key={item.id}
                              disablePadding
                              sx={{
                                selected: {
                                  backgroundColor: "red",
                                },

                              }}
                          >
                            <ListItemButton
                                sx={{
                                  "&.Mui-selected": {
                                    backgroundColor: "#2776CC",
                                    color: "#FFFFFF",
                                  },
                                  "&.MuiListItemButton-root:hover": {
                                    backgroundColor: "#2776CC",
                                    color: "#FFFFFF",
                                  },
                                }}
                                selected={selectedIndex === item.id}
                                onClick={(event) => handleListItemClick(event, item)}
                            >
                              <ListItemText>
                                <Typography
                                    variant="body2"
                                    sx={{
                                      fontWeight: selectedIndex === item.id && "600",
                                    }}
                                >
                                  {item.text}
                                </Typography>
                              </ListItemText>
                            </ListItemButton>
                          </ListItem>) : ("")
                      )
                  ))}
                </Collapse>


              </List>
            </Box>
            <Box>
              <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginRight: "20px",
                    marginBottom: "10px",
                  }}
              >
                <h5 style={{paddingLeft:"25px",cursor:"pointer",fontWeight:"normal",color:"#2027A5"}} onClick={onClickSupport}><a>Support</a></h5>
                <IconButton
                    onClick={() => {
                      //localStorage.removeItem(SESSION_KEY);
                      navigate("/");
                      setCustomersFromProps({});
                      setSelectedCustomerFromProps({});
                      setSelectedDistributionCenterFromProps({});
                      setLoadingPalletsDataFromProps(false);
                      setPalletsDataFromProps({});
                      setPalletInferenceIDFromProps("");
                      setPalletDetailsFromProps({});
                      setPageSubTitleFromProps("");
                      setPageChildTitleFromProps("");
                      setVorReferenceNumberFromProps("");

                      setPalletArchiveDataFromProps({});
                      setLoadingPalletsArchiveDataFromProps(false);
                     // Constants.SELECT_DATE = null;
                      //localStorage.clear();
                      Auth.signOut();
                      setTimeout(()=>{
                        //  window.location.reload();
                        let newloc = window.location.origin;
                        window.location.href = newloc;
                      },1000)

                    }}
                    aria-label="signOut"
                >
                  <LogoutIcon
                      sx={{
                        color: "#111540",
                      }}
                  />
                </IconButton>
              </Box>
              <Divider />
              <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginY: "20px",
                  }}
              >
                <img src={RehrigLogo} alt="rehrig-logo" />
              </Box>
            </Box>
          </Box>
        </Drawer>

        <Main open={open}>
          {location.pathname !== "/vor-gpt" ? (
              <DrawerHeader />
          ) : (
              <Box sx={{ mt: "0px",zIndex: 9999}} />
          )}
          {children}
        </Main>
      </Box>
  );
}

const sideNavDrawerStateToProps = (state) => {
  return {
    palletDetailsFromProps: state?.palletReview?.palletDetails,
    pageSubTitleFromProps: state?.palletReview?.pageSubTitle,
    pageChildTitleFromProps: state?.palletReview?.pageChildTitle,
    selectedLocationListData: state?.Routes?.selectedLocationListData,
    selectedCustomerListData: state?.Routes?.selectedCustomerListData,
    locationAlertsDataLoad: state?.Routes?.locationAlertsDataLoad,
    locationAlertsData: state?.Routes?.locationAlertsData,
    isStopScanPalletFromProps: state?.palletReview?.isStopScanPallet,
  };
};

const sideNavDrawerDispatchToProps = (dispatch) => {
  return {
    checkAccessFromProps: (value) => dispatch(checkAccess()),
    setPageSubTitleFromProps: (value) => dispatch(setPageSubTitle(value)),
    setPageChildTitleFromProps: (value) => dispatch(setPageChildTitle(value)),
    setVorReferenceNumberFromProps: (data) =>
        dispatch(setVorReferenceNumber(data)),
    setCustomersFromProps: (data) => dispatch(setCustomers(data)),
    setSelectedCustomerFromProps: (data) => dispatch(setSelectedCustomer(data)),

    setSelectedDistributionCenterFromProps: (data) =>
        dispatch(setSelectedDistributionCenter(data)),
    setLoadingPalletsDataFromProps: (data) =>
        dispatch(setLoadingPalletsData(data)),
    setPalletsDataFromProps: (data) => dispatch(setPalletsData(data)),
    setPalletInferenceIDFromProps: (data) =>
        dispatch(setPalletInferenceID(data)),
    setPalletDetailsFromProps: (data) => dispatch(setPalletDetails(data)),

    setPalletArchiveDataFromProps: (data) =>
        dispatch(setPalletArchiveData(data)),
    setLoadingPalletsArchiveDataFromProps: (data) =>
        dispatch(setLoadingPalletsArchiveData(data)),
    setStartRefreshFromProps: (value) => dispatch(setStartRefresh(value)),
    setStartDockDoorRefreshFromProps: (value) => dispatch(setStartDockDoorRefresh(value)),
    setResetEmbedURLFromProps: () => dispatch(resetEmbedURL()),
    setOpenNewURLAMI: (value) => dispatch(openNewURLAMI(value)),
    getUserDetails: (value) => dispatch(getUserDetails(value)),
    getAlertsForLocation: (customerLocationdata) => dispatch(getAlertsForLocation(customerLocationdata)),
    setStartStopScanPalletFromProps: (value) => dispatch(setStopScanPallet(value)),
    //getUserRole: () => dispatch(getUserRole())
  };
};

export default connect(
    sideNavDrawerStateToProps,
    sideNavDrawerDispatchToProps
)(SideNavDrawer);


